export enum LockerSize {
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large'
  }